export default "/images/headphones.svg?577f279c23a7ee0f4917041279533564";